<template>
  <div class="d-flex gap-3">
    <choice-box
      v-model="type"
      name="Lead Type"
      class="flex-1"
      label="Lead Type"
      type="lead_types"
      placeholder="None"
      data-cy="lead-type"
    ></choice-box>
    <choice-box
      v-model="source"
      name="Lead Source"
      class="flex-1"
      label="Lead Source"
      type="lead_sources"
      placeholder="None"
      data-cy="lead-source"
    ></choice-box>
  </div>
</template>

<script>
import ChoiceBox from "@/components/ChoiceBox.vue";
export default {
  components: {
    ChoiceBox
  },
  emits: ["change"],
  data() {
    return {
      type: "",
      source: ""
    };
  },
  watch: {
    type(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateForm(newValue, "lead_type");
      }
    },
    source(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateForm(newValue, "lead_source");
      }
    }
  },
  methods: {
    updateForm(value, name) {
      this.$emit("change", {
        value,
        name
      });
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.label) {
  font-weight: bold;
}
</style>
